<template>
  <div class="faq-features-section">
    <div class="faq-features-cotainer">
    <div class="faq-container">
      <h2 class="faq-title">{{$t('landing_page_faq_title')}}</h2>
      <div class="faq-item" v-for="(item, index) in faqList" :key="index">
        <button class="faq-question" :class="[ item.open ? 'set-border-radius' : '', $i18n.locale === 'ar' ? 'content-justification' : '']" @click="toggleFAQ(index)">
          <span :class="$i18n.locale === 'ar' ? 'arabic-text' : ''" >
            {{ $t(item.question) }}
          </span>
          <span class="faq-icon">{{ item.open ? "−" : "+" }}</span>
        </button>
        <p v-if="item.open" class="faq-answer" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ dispalyPriceInLabel(item.answer) }}</p>
      </div>
    </div>
    </div>

    <img src="../assets/images/bottom-left-tri.png" class="set-image-position" alt="Contenu">
  </div>
  </template>
  
  <script>
  import PriceMixin from '../mixins/price';

  export default {
		mixins: [PriceMixin],
    data() {
      return {
        faqList: [
          { question: "landing_page_question_1", answer: "landing_page_question_1_answer", open: false },
          { question: "landing_page_question_2", answer: "landing_page_question_2_answer", open: false },
          { question: "landing_page_question_3", answer: "landing_page_question_3_answer", open: false },
          { question: "landing_page_question_4", answer: "landing_page_question_4_answer", open: false },
          { question: "landing_page_question_5", answer: "landing_page_question_5_answer", open: false },
          { question: "landing_page_question_6", answer: "landing_page_question_6_answer", open: false },
          { question: "landing_page_question_7", answer: "landing_page_question_7_answer", open: false },
          { question: "landing_page_question_8", answer: "landing_page_question_8_answer", open: false }
        ]
      };
    },
    methods: {
      toggleFAQ(index) {
        this.faqList[index].open = !this.faqList[index].open;
      }
    }
  };
  </script>
  
  <style scoped>
  .faq-features-section {
    overflow: hidden;
  }
  .faq-features-cotainer {
    width: 100%;
    background-color: #020076;
    padding-block: 2%;
  }
  .set-image-position {
    margin-top: -5px;
  }
  .faq-container {
    max-width: 80%;
    margin: auto;
    /* background: #0b0b5a; */
    padding: 20px;
    /* border-radius: 10px; */
    color: white;

    @media (min-width: 1024px) {
      max-width: 55%;
      width: 50%;
    }
    @media (max-height: 480px) {
      max-width: 65%;
      width: 65%;
    }
    @media (orientation: portrait) {
      max-width: 95%;
      width: 95%;
    }
    
    @media (orientation: portrait) and (min-width: 1000px) {
      max-width: 75%;
      width: 75%;
    }
  }
  
  .faq-title {
    text-align: center;
    font-size: 2.2rem;
    margin-bottom: 20px;
    font-family: "Nunito-ExtraBold"
  }
  
  .faq-item {
    margin-bottom: 10px;
    /* border-bottom: 1px solid #ccc; */
  }
  
  .faq-question {
    width: 100%;
    text-align: left;
    background: #2929a3;
    color: white;
    padding: 15px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: "Nunito-Regular";

    .faq-icon {
      font-weight: bold;
      font-size: 1.2rem;
    }
    &.content-justification {
      justify-content: end;
      gap: 10px;
    }
  }
  .set-border-radius {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  .faq-question:hover {
    background: #3a3ab3;
  }
  
  .faq-answer {
    background: #1a1a80;
    padding: 15px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    line-height: 1.3;
    text-align: justify;
    font-family: "Nunito-Regular";
    color: white;
  }
  
  .icon {
    font-weight: bold;
    font-size: 1.2rem;
  }
  
  @media (max-width: 600px) {
    .faq-container {
      padding: 15px;
    }
    .faq-question {
      font-size: 0.9rem;
      padding: 12px;
    }
  }
  </style>
  